import { Link } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import RequestClass from "../../classes/RequestClass";
import { SYSTEM_CHOICES } from "../Enumerators";

export interface INavbarUser {
    system?: SYSTEM_CHOICES;
}

export const NavbarUser = (props: INavbarUser) => {
    const { isLogged, setIsLogged } = useContext(UserContext);

    const handleLogoutBtn = () => {
        const succ_callback = () => {
            sessionStorage.setItem("access_token", "");
            setIsLogged(false);
        };

        const err_callback = () => {
            sessionStorage.setItem("access_token", "");
            setIsLogged(false);
            //setNotification(RequestClass.errorAlert(result));
            // if (setIsUserInfoRead)
            //     setIsUserInfoRead(true)
        };

        RequestClass.makeRequest("logout/", null, succ_callback, err_callback);
    };

    return (
        <>
            {isLogged === true ? (
                <>
                    <a className="ml-1 " href="/szkolenia/kursy">
                        <a className="button px-2 py-1">Moje kursy</a>
                    </a>
                    {/* <Link to="/kursy" reloadDocument className="ml-1">
                        <a className="button px-2 py-1">Moje kursy</a>
                    </Link> */}
                    {/* <Link to="/kursy" reloadDocument className="ml-1">
                        <a className="button px-2 py-1">Bieg Belfrów</a>
                    </Link> */}
                    <a className="ml-1 " href={"https://biegbelfrow.pl/redirect/" + RequestClass.getToken()}>
                        <a className="button px-2 py-1">Bieg Belfrów</a>
                    </a>
                    <Link to="/konto" reloadDocument className="ml-1">
                        <a className="button px-2 py-1">Konto</a>
                    </Link>

                    <a className="ml-1" onClick={handleLogoutBtn} title="Wyloguj">
                        <a className="button px-2 py-2">
                            <i className="fa-solid fa-right-from-bracket"></i>
                        </a>
                    </a>
                </>
            ) : (
                <>
                    <div className="buttons">
                        {props.system === SYSTEM_CHOICES.SYSTEM_BB ? (
                            <Link to="/zapisy" reloadDocument>
                                <a className="button is-primary">Zapisz się</a>
                            </Link>
                        ) : (
                            <Link to="/rejestracja" reloadDocument>
                                <a className="button is-primary">Zarejestruj</a>
                            </Link>
                        )}
                        <Link to="/login" reloadDocument>
                            <a className="button is-light">Zaloguj</a>
                        </Link>
                    </div>

                    {/* <Link to="/rejestracja" reloadDocument className="navbar-item">
                        Rejestracja
                    </Link>
                    <Link to="/login" reloadDocument className="navbar-item">
                        Zaloguj
                    </Link> */}
                </>
            )}
        </>
    );
};
